import React from 'react';
import * as S from './styles';
import { Button } from '@veneer/core';
import { HPapp } from 'src/assets/images';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

const NextStepsSection: React.FC = () => {
  const getText = useTranslationHelper();

  const handleExploreApp = () => {
    // Handle navigation to HP app
    console.log('Navigate to HP app');
  };

  return (
    <S.NextStepsContainer>
      <S.HPAppSection>
        <S.NextStepsCard>
          <S.NextStepsContentLeft>
            <S.NextStepsTitle>
              {getText(
                'confirmation.getReadyTitle',
                'Get ready for your new printer'
              )}
            </S.NextStepsTitle>

            <S.NextStepsDescription>
              {getText(
                'confirmation.appDescription',
                'Use the HP app to track your order and set up your printer when it arrives. Then scan, send, and print right from the app.'
              )}
            </S.NextStepsDescription>
            <S.AppButton onClick={handleExploreApp}>
              <Button appearance="secondary">
                {getText('confirmation.exploreApp', 'Explore the HP app')}
              </Button>
            </S.AppButton>
          </S.NextStepsContentLeft>
          <S.NextStepsContentRight>
            <S.ImageContainer>
              <S.ItemImage
                src={HPapp}
                alt="HP"
              />
            </S.ImageContainer>
          </S.NextStepsContentRight>
        </S.NextStepsCard>
      </S.HPAppSection>
    </S.NextStepsContainer>
  );
};

export default NextStepsSection;
